import { render, staticRenderFns } from "./UnverifiedPhotos.vue?vue&type=template&id=4cc062f0&scoped=true&"
import script from "./UnverifiedPhotos.vue?vue&type=script&lang=js&"
export * from "./UnverifiedPhotos.vue?vue&type=script&lang=js&"
import style0 from "./UnverifiedPhotos.vue?vue&type=style&index=0&id=4cc062f0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cc062f0",
  null
  
)

export default component.exports